import { render, staticRenderFns } from "./CategoryRow.vue?vue&type=template&id=c0a50d36&scoped=true"
import script from "./CategoryRow.vue?vue&type=script&lang=js"
export * from "./CategoryRow.vue?vue&type=script&lang=js"
import style0 from "./CategoryRow.vue?vue&type=style&index=0&id=c0a50d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a50d36",
  null
  
)

export default component.exports